window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.StickyHeader = {

        settings: {
            didScroll: false,
            lastScrollTop: window.pageYOffset || document.documentElement.scrollTop,
            scrollUpInPx: 0
        },

        init: function () {
            OKJS.StickyHeader.settings.logoBar = document.querySelector('header .runway--grey-white');
            OKJS.StickyHeader.settings.stickyNav = document.querySelector('.runway--mobile-topnav');
            OKJS.StickyHeader.settings.serviceMessageActive = document.querySelector('service-beskeder-bjaelke') ? true : false;

            var settings = this.settings;

            if (window.innerWidth <= 768 && settings.logoBar) {

                var throttledStickyHeader = OKJS.Global.throttle(function () {
                    try {
                        OKJS.StickyHeader.updateSticky(settings);
                    } catch (error) {
                        console.error(error);
                    }
                }, 25, { trailing: false });

                window.addEventListener('scroll', function () {
                    requestAnimationFrame(throttledStickyHeader);

                }, Modernizr.passiveeventlisteners ? { passive: true } : false);
            }
        },

        updateSticky: function (settings) {
            var st = window.pageYOffset || document.documentElement.scrollTop;

            if (!settings.logoBar) {
                return;
            }

            /*if (settings.serviceMessageActive) {
                var serviceMessage = document.querySelector('.service-message .message');

                var pageHeaderElement = document.querySelector('.page-header');
                if (pageHeaderElement){
                    pageHeaderElement.style.top = serviceMessage.offsetHeight + "px";
                }
            }*/

            var serviceMessage = {
                offsetHeight: 0
            };

            // make the mobilnav sticky if it's past the logobar
            if (st > (settings.logoBar.offsetHeight + (settings.serviceMessageActive ? serviceMessage.offsetHeight : 0))) {
                settings.stickyNav.classList.add("scroll-sticky");
            } else {
                settings.stickyNav.classList.remove("scroll-down");
                settings.stickyNav.classList.remove("scroll-sticky");
            }

            // hide the sticky mobilenav if scrolling down - but not before the user has scrolled +200px. If going up we wait 200px then show it again 
            if (st > settings.lastScrollTop && st > (200 + (settings.serviceMessageActive ? serviceMessage.offsetHeight : 0))) {
                // Scroll Down
                settings.stickyNav.classList.remove("scroll-up");
                settings.stickyNav.classList.add("scroll-down");
                settings.scrollUpInPx = 0;

            } else {
                // Scroll Up
                if (settings.scrollUpInPx === 0) {
                    settings.scrollUpInPx = st;
                }
                if ((settings.scrollUpInPx - st) > 200) {

                    if (settings && settings.logoBar && settings.logoBar.offsetHeight && st > settings.logoBar.offsetHeight) {
                        settings.stickyNav.classList.remove("scroll-down");
                        settings.stickyNav.classList.add("scroll-up");
                    } else {
                        settings.stickyNav.classList.remove("scroll-up");
                        settings.stickyNav.classList.remove("scroll-down");
                    }
                }
            }

            settings.lastScrollTop = st;
        }
    };
}(window.OKJS));
